module.exports = __webpack_public_path__ + "img/default_brown.9f3ec5dd.svg";